export const MOMENT_YEAR_MONTH_FORMAT = "MM/YYYY";
